<div *ngIf="!isMobileView" class="login-desktop text">
  <form class="login-form" [formGroup]="loginDatas">
    <div class="login-item">
      <inputb3 formControlName="userName" fPlaceholder="{{ 'user_name' | t }}" fInputType="input_text" fID="login_userName"></inputb3>
    </div>
    <div class="login-item">
      <inputb3 formControlName="userPassword" fPlaceholder="{{ 'password' | t }}" fInputType="password" extraClass="loginPassword" fID="login_userPassword"></inputb3>

      <div class="forget-pass">
        <a (click)="this._UiHelper.toogleForgotPass()" *ngIf="!env">{{ 'Forgot_Password' | t }}?</a>
      </div>
    </div>
  </form>
  <div class="item-row" *ngIf="isError">
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
  <div class="item-row">
    <div class="checkbox">
      <input type="checkbox" />
    </div>
    <div class="check-label">{{ 'AutoLogin' | t }}</div>
  </div>

  <div class="item-row" *ngIf="isError">
    <a href="https://help-center.bet3000.de/hc/de">
      <div class="btn colored register-button login-dropdown-btn">
        <div class="contact-btn-text">
          {{ 'Contact' | t }}
        </div>
      </div>
    </a>
  </div>
  <div class="item-row" (click)="submitLoginData()">
    <div class="btn colored login-dropdown-btn">
      <div class="login-dropdown-btn-text">{{ 'Login' | t }}</div>
    </div>
  </div>

  <div class="item-row">
    <div class="unregister">{{ 'DontHaveAccount' | t }}</div>
    <div class="register" [routerLink]="['/register']">{{ 'Register' | t }}</div>
  </div>
</div>
<div *ngIf="isMobileView" class="login-mobile text">
  <div class="sidenav-header">
    <div class="left">{{ 'Login' | t }}</div>
    <div class="right" (click)="closeSideBar()">&times;</div>
  </div>
  <form class="login-mobile-form" [formGroup]="loginDatas">
    <div class="login-item">
      <!--      <input-->
      <!--        placeholder="{{ 'user_name' | t }}"-->
      <!--        type="text"-->
      <!--        formControlName="userName"-->
      <!--        class="login-input"-->
      <!--      />-->

      <inputb3 formControlName="userName" fPlaceholder="{{ 'user_name' | t }}" fInputType="input_text" fID="login_userName"></inputb3>
    </div>
    <div class="login-item">
      <!--      <input-->
      <!--        placeholder="{{ 'password' | t }}"-->
      <!--        type="password"-->
      <!--        formControlName="userPassword"-->
      <!--      />-->

      <inputb3 formControlName="userPassword" fPlaceholder="{{ 'password' | t }}" fInputType="password" extraClass="loginPassword" fID="login_userPassword"></inputb3>

      <div class="forget-pass" (click)="this._UiHelper.toogleForgotPass()">{{ 'Forgot_Password' | t }}?</div>
    </div>
  </form>
  <div class="login-container">
    <div class="login-row" *ngIf="isError">
      <div class="error-message">
        {{ errorMessage }}
      </div>
    </div>
    <div class="login-row" (click)="submitLoginData()">
      <div class="btn mobile colored register-button">
        <div class="btn-text mobile-text">
          {{ 'Login' | t }}
        </div>
      </div>
    </div>
    <div class="login-row">
      <div class="checkbox">
        <input type="checkbox" />
      </div>
      <div class="check-label">{{ 'AutoLogin' | t }}</div>
    </div>
    <div class="login-row" *ngIf="isError">
      <div class="btn mobile colored register-button" (click)="contactButton()">
        <div class="btn-text mobile-text">
          {{ 'Contact' | t }}
        </div>
      </div>
    </div>
    <div class="login-row" *ngIf="this.IsRegisterActive">
      <div class="btn mobile colored green">
        <div class="btn-text mobile-text-white" (click)="closeSideBar()" [routerLink]="['/register']">
          {{ 'RegisterNow' | t }}
        </div>
      </div>
    </div>
  </div>
</div>
